import { useSelector } from 'react-redux';

import { EReportStatus } from '../../../constants/report';
import { getReportState } from '../../../selectors/report';

export function useIsCommentDisabled() {
  const { reportStatus } = useSelector(getReportState);

  return [EReportStatus.Finished, EReportStatus.Share].includes(reportStatus);
}
